import {
  CreateClientType,
  GetClientsType,
  ClientBaseType,
  UpdateClientType,
  CreateStatusClientType,
  StatusClientType,
  StatusUpdateClientType,
} from '@customTypes/client'

import {
  CreateEventStatusType,
  CreateEventType,
  CreateEventTypeType,
  DeleteEventsType,
  EventBaseType,
  EventTypeType,
  GetEventsType,
  StatusEventType,
  UpdateEventType,
} from '@customTypes/event'

abstract class ClientEntityDS {
  //Clients
  abstract getClients(params: GetClientsType): Promise<ClientBaseType[]>

  abstract getClientById(id: string): Promise<ClientBaseType>

  abstract createClient(client: CreateClientType): Promise<ClientBaseType>

  abstract updateClient(client: UpdateClientType): Promise<void>

  abstract deleteClient(id: string): Promise<void>

  abstract deleteClients(ids: string[]): Promise<void>

  abstract getEvents(params: GetEventsType): Promise<EventBaseType[]>

  abstract createEvent(params: CreateEventType): Promise<EventBaseType>

  abstract updateEvent(params: UpdateEventType): Promise<void>

  abstract deleteEvent(id: string): Promise<void>

  abstract deleteEvents(params: DeleteEventsType): Promise<void>

  // Status client
  abstract createStatus(params: CreateStatusClientType): Promise<StatusClientType>

  abstract updateStatus(params: StatusClientType): Promise<void>

  abstract updateOrderStatus(params: StatusClientType[]): Promise<void>

  abstract deleteStatus(statusId: string): Promise<void>

  abstract getStatusByClientId(clientId: string): Promise<StatusClientType | null>

  abstract getStatus(): Promise<StatusClientType[]>

  abstract getStatusHistory(clientId: string): Promise<StatusUpdateClientType[]>

  // Event type
  abstract createEventType(params: CreateEventTypeType): Promise<EventTypeType>

  abstract updateEventType(params: EventTypeType): Promise<void>

  abstract deleteEventType(id: string): Promise<void>

  abstract getEventTypeOptions(): Promise<EventTypeType[]>

  // Event status
  abstract createEventStatus(params: CreateEventStatusType): Promise<StatusEventType>

  abstract updateEventStatus(params: StatusEventType): Promise<void>

  abstract updateOrderEventStatus(params: StatusEventType[]): Promise<void>

  abstract deleteEventStatus(id: string): Promise<void>

  abstract getEventStatusOptions(): Promise<StatusEventType[]>
}

export default ClientEntityDS
